import { styled } from 'styled-components';
import { Button } from '@/shared/ui/form/button';
import { Image } from '@/shared/ui/image';

const flexColumnCenter = `
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
  height: ${(props) => (props.$height ? props.$height : '100vh')};
  padding: 18px;
  gap: 3px;
  text-align: center;
  background: #131315;
  box-shadow: 0 0 250px 50px #131315;
  border-radius: 12px;
  border: 1px solid #131315;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
    border: none;
    max-height: fit-content;
  }
`;

export const FormGroup = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-top: 34px;
  padding: 22px;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 56px;
  }
`;

export const FormGroupItem = styled.div`
  ${flexColumnCenter}
  text-align: left;
  gap: 24px;
`;

export const FormGroupButton = styled(FormGroupItem)`
  gap: 12px;
`;
